import apiConfig from "@/config/apiConfig";

const rootPath = apiConfig.companyApi;

// 成果管理
export const achievementInfo = {
    pageList: rootPath + "/technologyAchievements/pageList", // 分页查询(get)
    saveOrUpdate: rootPath + "/technologyAchievements/saveOrUpdate", // 修改(put)
    detail: rootPath + "/technologyAchievements/detail", // 根据id查询详情(get)
    remove: rootPath + "/technologyAchievements/remove/", // 删除/批量删除-根据ids(post)
    eveluation: rootPath + "/technologyAssess/detailByDid", //  根据did获取评价详情
    expertList: rootPath + "/technologyExpert/list",   // 专家无分页
}

// 技术需求管理
export const technicalRequirementsInfo = {
    pageList: rootPath + "/technologyTechnicalRequirements/pageList", // 分页查询(get)
    saveOrUpdate: rootPath + "/technologyTechnicalRequirements/saveOrUpdate",     // 新增/修改
    remove: rootPath + "/technologyTechnicalRequirements/remove/", // 删除/批量删除-根据ids(post)
    detail: rootPath + '/technologyTechnicalRequirements/detail'
}

// 项目管理
export const corpProjectInfo = {
    pageList: rootPath + "/technologyProject/pageList", // 分页查询(get)
    noPageList: rootPath + "/technologyProject/getList", // 无分页查询(get)
    saveOrUpdate: rootPath + "/technologyProject/saveOrUpdate", // 修改(put)
    detail: rootPath + "/technologyProject/detail", // 根据id查询详情(get)
    remove: rootPath + "/technologyProject/remove/", // 删除/批量删除-根据ids(post)
}

// 项目评估
export const projectEvaluationInfo = {
    pageList: rootPath + "/technologyProjectEvaluation/pageList", // 分页查询(get)
    saveOrUpdate: rootPath + "/technologyProjectEvaluation/save", // 修改(put)
    detail: rootPath + "/technologyProjectEvaluation/detail", // 根据id查询详情(get)
    remove: rootPath + "/technologyProjectEvaluation/remove/", // 删除/批量删除-根据ids(post)
}

// 项目对接列表
export const technologyDemandInfo = {
    pageList: rootPath + "/technologyDemandDocking/pageList", // 分页查询(get)
    saveOrUpdate: rootPath + "/technologyDemandDocking/save", // 修改(put)
}

// 技术经理人信息
export const technologyManagerInfo = {
    saveOrUpdate: rootPath + "/technologyManager/update", // 修改(put)
    detail: rootPath + "/technologyManager/detail",
    getPageList: rootPath + "/technologyManager/pageList",   // 查询自己对接的技术需求
    demandDetail: rootPath + "/technologyManager/tRdetail", // 查询自己对接的技术需求详情
}

// 门户

// 科技成果二级
export const achievementFontInfo = {
    pageList: rootPath + "/web/technologyAchievements/pageList", // 分页查询(get)
    noPageList: rootPath + "/web/technologyAchievements/list", // 无分页查询(get)
    detail: rootPath + "/web/technologyAchievements/detail", // 根据id查询详情(get)
    saveOrUpdate: rootPath + "/technologyAchievementsDocking/saveOrUpdate", // 点击联系技术方
    getAchievementList: rootPath + '/technologyAchievementsDocking/pageList', // 获取联系技术方列表
    pingjiaList: rootPath + '/web/technologyAssess/pageList',  // 获取成果评价列表
    pingjiaDetail: rootPath + "/web/technologyAssess/detail",  // 获取成果评价详情
    projectPageList: rootPath + "/web/technologyProject/pageList",  // 优质项目分页列表
    projectDetail: rootPath + "/web/technologyProject/detail",  // 优质项目详情
    save: rootPath + "/technologyDemandDocking/save",  // 点击联系项目方
    demandPageList: rootPath + "/web/technologyTechnicalRequirements/pageList",  // 技术需求分页列表
    demandDetail: rootPath + "/web/technologyTechnicalRequirements/detail", // 技术需求详情
    getHetong: rootPath + '/web/basicsEssayInfo/pageList', // 获取技术合同
    hetongDetail: rootPath + "/web/basicsEssayInfo/detail", // 技术合同详情
    detailFlow: rootPath + "/web/basicsEssayInfo/detailFlow", // 技术合同详情
    tradeList: rootPath + "/web/webtechnologyTransactionController/pageList", // 成果交易列表  技术转让0   技术需求1
    tradeDetail: rootPath + "/web/webtechnologyTransactionController/detail",
}

export const basicsAchievement = {
    pageList: rootPath + "/web/basicsAchievement/pageList",
    detail: rootPath + "/web/basicsAchievement/detail",
}
